import { chargePointActionTypes } from "../actionTypes/chargePoint.actionTypes";

const initialState = {
  loading: false,
  error: null,
  chargePoint: null,
};

const chargePointReducer = (state = initialState, action) => {
  switch (action.type) {
    case chargePointActionTypes.GET_CHARGE_POINT_REQUEST:
    case chargePointActionTypes.START_GET_OPEN_CHARGING_TRANSACTION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case chargePointActionTypes.GET_CHARGE_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        chargePoint: action.payload,
      };

    case chargePointActionTypes.GET_OPEN_CHARGING_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case chargePointActionTypes.GET_CHARGE_POINT_FAILURE:
    case chargePointActionTypes.START_CHARGING_TRANSACTION_FAILURE:
    case chargePointActionTypes.GET_OPEN_CHARGING_TRANSACTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case chargePointActionTypes.RESET_SELECTED_CHARGE_POINT:
      return {
        ...state,
        loading: false,
        chargePoint: null,
      };

    default:
      return state;
  }
};

export default chargePointReducer;
